// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"TermsOfUse_wrapper__1pOVV"};